import { KeyboardEvent } from 'react'

// simple interface for logging
export function log(...args: any[]) {
  console.log(...args)
}

// simple interface for generation/tracking errors
export function fail(err: string, ...args: any[]) {
  console.error('ERROR', err, ...args)
  throw err
}

// async sleep
export async function sleep(ms: number): Promise<void> {
  return new Promise((res, _ ) => {
    setTimeout(() => { res() }, ms)
  })
}

// String Template for URI paths, encoding all expressions
export function uri(frags: TemplateStringsArray, ...params: any[]): string {
  let out = frags[0]
  for (let i=0; i<params.length; i++) {
    out += encodeURIComponent(params[i]) + frags[i+1]
  }
  return out
}

// create keydown handler for capturing enter down events
export function enterDown(handler: () => any) {
  return (e: KeyboardEvent) => {
    if (e.key == 'Enter' && !(e.altKey || e.ctrlKey || e.metaKey || e.shiftKey)) {
      e.stopPropagation()
      handler()
      return false
    }
  }
}
